import { Chip, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { CustomerBaseDto } from "../../types";
import { getActiveSubscriptions } from "../../api/service/customerbaseApi";

interface CBCarSharingStatusProps {
    customer: CustomerBaseDto | null;
}

const CBCarSharingStatus = ({ customer }: CBCarSharingStatusProps) => {
    const [hasActiveCarSharingSubscription, setHasActiveCarSharingSubscription] = useState(false);
    const theme = useTheme();

    useEffect(() => {
        const fetchActiveCarSharingSubscriptions = async () => {
            if (customer?.cbCustomerId && customer?.csData?.modPersonId) {
                try {
                    const response = await getActiveSubscriptions(
                        customer.cbCustomerId,
                        customer.csData.modPersonId
                    );
                    if (response && response.length > 0) {
                        setHasActiveCarSharingSubscription(true);
                    }
                } catch (error) {
                    console.error("Error fetching active car-sharing subscriptions:", error);
                }
            }
        };

        fetchActiveCarSharingSubscriptions();
    }, [customer]);

    if (!hasActiveCarSharingSubscription) {
        return null;
    }

    return (
        <Chip
            label="CARSHARING"
            sx={{
                color: "white",
                backgroundColor: theme.palette.success.main,
            }}
        />
    );
};

export default CBCarSharingStatus;
